<template>
  <div class="bg">
    <home-footer-info></home-footer-info>
    <home-tel></home-tel>
    <home-about-us></home-about-us>
    <home-rights></home-rights>
  </div>
</template>

<script>
  import HomeFooterInfo from './HomeFooterInfo.vue'
  import HomeTel from './HomeTel.vue'
  import HomeAboutUs from './HomeAboutUs'
  import HomeRights from './HomeRights'
  export default {
    name: 'HomeFooter',
    components: {
      HomeAboutUs,
      HomeFooterInfo,
      HomeTel,
      HomeRights
    }
  }
</script>

<style scoped>
.mart95{

    margin-top: 95px;
}
  .bg {
    background-color: rgb(242,242,242);
  }
</style>



// WEBPACK FOOTER //
// HomeFooter.vue?353a4a87